<template lang="pug">
    el-dialog(:title="title",width="95%",:visible.sync='visible' :modal-append-to-body='false' :append-to-body="true")
        el-form(:model="ruleForm",:inline="false", :rules="rules", ref="ruleForm" label-width="120px")
            el-card(shadow="never")
                div(slot="header")
                    font(style="font-weight: bold;font-size:18px;") 教练基本信息
                div.labelStyle
                    //- el-form-item(label="比赛ID:" prop="matchId")
                    //-     font {{ruleForm.matchId}}
                    el-form-item(label="教练姓名:" prop="name")
                        font {{ruleForm.pxCoachSimpleVO.name}}
                    el-form-item(label="手机号码:" prop="phone")
                        font {{ruleForm.pxCoachSimpleVO.phone}}
                    el-form-item(label="等级:" prop="coachLevel")
                        font {{ruleForm.pxCoachSimpleVO.coachLevel}}&nbsp;{{ruleForm.cityName}}
                    el-form-item(label="级别:" prop="leve")
                        font {{ruleForm.pxCoachSimpleVO.leve}}
                    el-form-item(label="性别:" prop="sex")
                        font(v-if="ruleForm.pxCoachSimpleVO.sex === 0") 男
                        font(v-if="ruleForm.pxCoachSimpleVO.sex === 1") 女
                    el-form-item(label="授课时数:" prop="classHours")
                        font {{ruleForm.pxCoachSimpleVO.classHours}}
                    el-form-item(label="教练资质:" prop="intelligence")
                        font {{ruleForm.pxCoachSimpleVO.intelligence}}
                        //- font(v-if="ruleForm.projectType === 1") 单打
                        //- font(v-if="ruleForm.projectType === 2") 双打
                    el-form-item(label="教练标签:" prop="label")
                        font {{ruleForm.pxCoachSimpleVO.label}}
                    //- el-form-item(label="add赛制:")
                        font {{ruleForm.matchFormat}}
                    el-form-item(label="教练头像:" prop="imgList")
                        <img :src="listImageUrl" :onerror="defaultImg" style="width:245px;height:178px;"/>
                    el-form-item(label="运动经历:" prop="sportsExperience")
                        <div v-html="ruleForm.pxCoachSimpleVO.sportsExperience" ></div>
            br
            el-card(shadow="never")
                div(slot="header")
                    font(style="font-weight: bold;font-size:18px;") 课程信息
                div.labelStyle
                    el-form-item(label="课程名称:" prop="name")
                        font {{ruleForm.pxSubscribeCoachCourseVO.name}}
                    el-form-item(label="班级人数:" prop="count")
                        font {{ruleForm.pxSubscribeCoachCourseVO.count}}
                    el-form-item(label="会员级别:" prop="count")
                        font {{ruleForm.pxSubscribeCoachCourseVO.memberLevel}}
                    el-form-item(label="课时费:")
                        font {{ruleForm.pxSubscribeCoachCourseVO.hourFee}}&nbsp;&nbsp; 元/人
                    el-form-item(label="课程内容" prop="content")
                        font {{ruleForm.pxSubscribeCoachCourseVO.content}}
            br
            el-card(shadow="never")
                div(slot="header" )
                    font(style="font-weight: bold;font-size:18px;") 预约时间及场地设置
                div
                    el-table(:data="ruleForm.subscribeCoachTimeVOList" border)
                        el-table-column(prop='index' label="序号"  align='center', width='100')
                        el-table-column(prop="date" label="预约日期" align='center')
                        el-table-column(prop="time" label="预约时间段" align='center')
                        el-table-column(prop="spaceName" label="预约场地" align='center')
                            //- template(slot-scope="scope")
                            //-     font ￥&nbsp;{{scope.row.price}}元
            br
            el-card(shadow="never")
                div(slot="header")
                    font(style="font-weight: bold;font-size:18px;") 退款设置
                div
                    el-table(:data="ruleForm.businessRefundVOList" border)
                        el-table-column(prop='index' label="序号"  align='center', width='100')
                        el-table-column(prop="hours" label="距比赛开始时间/小时（含）" align='center')
                        el-table-column(prop="rate" label="退款比例/%" align='center')
            //- br
            //- el-card(shadow="never")
            //-     div(slot="header")
            //-         font(style="font-weight: bold;font-size:18px;") 电子证书设置
            //-     div
                    //- el-table(:data="ruleForm.ctRefundList" border)
                    //-     el-table-column(prop='index' label="序号"  align='center', width='100')
                    //-     el-table-column(prop="minDuration" label="距比赛开始时间/小时（含）" align='center')
                    //-     el-table-column(prop="refundScale" label="退款比例/%" align='center')
            br
            el-card(shadow="never" v-if="type == 'release'")
                div(slot="header")
                    font(style="font-weight: bold;font-size:18px;") 审核意见
                div
                    el-form-item(prop="verifyReason" label="填写审核意见:")
                        el-input(v-model="ruleForm.verifyReason" type="textarea" :rows=5 resize="none")
        span.dialog-footer(slot="footer" v-if="!type")
            el-button(@click="visible=false") 返 回
        //- //审核发布
        span.dialog-footer(slot="footer" v-if="type == 'release'")
            el-button(@click="releaseSubmit(1)" type="primary") 发 布
            el-button(@click="releaseSubmit(2)" type="danger") 拒 绝
            el-button(@click="visible=false") 取 消
        //- //支付弹窗组件
        zfpage(:openfree='visibleFee' :record='record' v-if="visibleFee" @zfsuccess="zfsuccess")

</template>
<script>
import zfpage from '../zfpage.vue'
export default {
  components: {
    zfpage
  },
  data () {
    return {
      visibleFee: false,
      record: {},
      type: '',
      title: '查看详情',
      defaultImg: '',
      listImageUrl: '',
      imageUrl: 'http://132.232.17.66:8888/',
      detailImageUrl: '',
      tableData: [],
      ruleForm: {
        id: null,
        imgList: '',
        pxCoachSimpleVO: {
          name: ''
        },
        pxSubscribeCoachCourseVO: {
          name: ''
        },
        ctRefundList: [],
        verifyReason: ''
      },
      visible: false,
      rules: {
        // verifyReason: [
        //     { required: true, message: '审核意见不能为空!', trigger: 'blur' },
        //     {max: 200, message: '审核意见长度不能超过200个字符!'}
        // ]
      }
    }
  },
  methods: {
    zfsuccess (data) {
      this.visibleFee = false
      if (data == 1) {
        // this.$showLoading()
        this.$http({
          url: this.$http.adornUrl(`/frFranchiseFeeRecord/checkPayStatus`),
          method: 'post',
          data: {
            busId: this.ruleForm.id,
            busType: 1,
            busCategory: 1
          }
        }).then((data) => {
          if (data && data.code === 0) {
            this.visible = false
            //缴费成功，直接发布
            this.updateState(2)
          } else {
            this.$message.error(data.msg)
          }
        })
      }
    },
    init (id, type) {
      this.title = '查看详情'
      this.ruleForm.id = id || null
      this.visible = true
      this.type = type
      if (type == 'release') {
        this.title = '审核发布'
        // this.finachiseFeePay()
      }
      this.ruleForm.verifyReason = ''
      //回选
      if (this.ruleForm.id) {
        this.$http({
          url: this.$http.adornUrl(`/pxSubscribe/info/` + this.ruleForm.id),
          method: 'get'
        }).then((data) => {
          if (data && data.code === 0) {
            this.ruleForm = data.data
            this.listImageUrl = data.data.pxCoachSimpleVO.headPortrait
            //   this.detailImageUrl = data.bean.imgUrlDetail
            //   this.ruleForm.applyDate = []
            //   this.ruleForm.applyDate.push(data.bean.matchSignStartTime)
            //   this.ruleForm.applyDate.push(data.bean.matchSignEndTime)
            //   this.ruleForm.ctRefundList = []
            if (data.data.subscribeCoachTimeVOList != null) {
              for (
                let i = 0;
                i < data.data.subscribeCoachTimeVOList.length;
                i++
              ) {
                this.ruleForm.subscribeCoachTimeVOList[i].index = i + 1
              }
            }
            if (data.data.businessRefundVOList != null) {
              for (let i = 0; i < data.data.businessRefundVOList.length; i++) {
                this.ruleForm.businessRefundVOList[i].index = i + 1
              }
            }
            //   this.ruleForm.verifyReason = ''
            //   let index = 1
            //   for (let i of data.rList) {
            //     this.ruleForm.ctRefundList.push({
            //       index: index++,
            //       minDuration: i.minDuration,
            //       refundScale: i.refundScale
            //     })
            //   }
          }
        })
      }
    },
    releaseSubmit (type) {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (type === 1) {
            this.$confirm('确认发布?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(async () => {
              // //查询是否需要预缴加盟费，需要则先交费，不需要则直接发布
              // //status状态(0未缴费，1已缴费，2已退费)
              // if (this.record.type === 1 && this.record.status === 0) {
              //   //仅未支付预缴费时，展示二维码支付页面
              //   this.visibleFee = true
              // } else {
              //   //不是预缴费，则直接发布
              //   this.updateState(type)
              // }
              this.updateState(type)
            })
          } else if (type === 2) {
            this.$confirm('确认拒绝?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(async () => {
              // //查询是否需要预缴加盟费，需要则先交费，不需要则直接发布
              // //status状态(0未缴费，1已缴费，2已退费)
              // if (this.record.type === 1 && this.record.status === 0) {
              //   //仅未支付预缴费时，展示二维码支付页面
              //   this.visibleFee = true
              // } else {
              //   //不是预缴费，则直接发布
              //   this.updateState(type)
              // }
              this.updateState(type)
            })
          }
        }
      })
    },
    //查询是否需要预缴加盟费，需要则先交费，不需要则直接发布
    // finachiseFeePay () {
    //   this.$http({
    //     url: this.$http.adornUrl(`/pxSubscribe/publish/` + this.ruleForm.id),
    //     method: 'get',
    //     params: this.$http.adornParams({
    //       remark: this.ruleForm.verifyReason
    //     })
    //   }).then((data) => {
    //     if (data && data.code === 0) {
    //       this.record = data.record
    //       console.log('record', this.record)
    //     } else {
    //       this.$message.error(data.msg)
    //     }
    //   })
    // },
    updateState (type) {
      this.$http({
        url: this.$http.adornUrl(`/pxSubscribe/publish/` + this.ruleForm.id),
        method: 'get',
        params: this.$http.adornParams({
          state: type,
          id: this.ruleForm.id,
          remark: this.ruleForm.verifyReason
        })
      }).then((data) => {
        if (data && data.code === 0) {
          this.$message({
            message: '审核成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        } else {
          this.$message.error(data.msg)
        }
      })
    }
  }
}
</script>
<style>
.el-table__header {
  width: 100% !important;
}
.el-table__body {
  width: 100% !important;
}
* {
  margin: 0;
}
</style>
